// Frontend mirror of backend/naming.py DISPLAY_LABELS.
// Single source of truth for enum → Italian humanization in Wizard/Dashboard/CRM.
export const DISPLAY_LABELS = {
  // Material support
  originale: "Originale",
  scansione: "Scansione integrale",
  scansione_colori: "Scansione a colori",
  scansione_bn: "Scansione in bianco e nero",
  fotocopia: "Fotocopia",
  fotocopia_colori: "Fotocopia a colori",
  fotocopia_bn: "Fotocopia in bianco e nero",
  fotografia: "Fotografia",
  riproduzione_digitale: "Riproduzione digitale",
  // Original status
  existing_available: "Originale disponibile",
  existing_not_available: "Originale esistente ma non disponibile",
  existence_not_verified: "Esistenza dell'originale non verificata",
  not_existing: "Originale non esistente",
  // Roles
  principale: "Principale",
  secondario: "Secondario",
  accessorio: "Accessorio",
  // Graphic object
  firma_singola: "Firma singola",
  piu_firme: "Più sottoscrizioni",
  manoscritto: "Manoscritto",
  olografo: "Testamento olografo",
  // Assessment
  insufficiente: "Insufficiente",
  parziale: "Parziale",
  adeguata: "Adeguata",
  non_completamente_valutabile: "Non completamente valutabile",
  elevata: "Elevata",
  buona: "Buona",
  ridotta: "Ridotta",
  media: "Media",
  ottima: "Ottima",
  limitata: "Limitata",
  molto_limitata: "Molto limitata",
  // Temporal
  coeva: "Coeva",
  antecedente_prossima: "Antecedente prossima",
  successiva_prossima: "Successiva prossima",
  antecedente: "Antecedente",
  successiva: "Successiva",
  antecedente_remota: "Antecedente remota",
  successiva_remota: "Successiva remota",
  non_determinabile: "Non determinabile",
  // Date precision
  exact: "Data esatta",
  month_year: "Mese e anno",
  year_only: "Solo anno",
};

export function humanize(value) {
  if (value == null || value === "") return "—";
  const key = String(value).toLowerCase();
  if (DISPLAY_LABELS[key]) return DISPLAY_LABELS[key];
  // fallback: replace underscores and capitalize
  return String(value).replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

// Assumability badge classes
export function assumabilityColor(level) {
  if (!level) return "border-slate-300 text-slate-600 bg-slate-100";
  const s = level.toLowerCase();
  if (s.startsWith("non ancora")) return "border-forensic-red text-forensic-red bg-forensic-red/10";
  if (s.startsWith("assumibile con")) return "border-orange-600 text-orange-700 bg-orange-100";
  if (s === "assumibile") return "border-forensic-green text-forensic-green bg-forensic-green/10";
  if (s.startsWith("dati")) return "border-slate-400 text-slate-700 bg-slate-200";
  return "border-slate-300 text-slate-600 bg-slate-100";
}

export function workabilityColor(level) {
  const s = (level || "").toLowerCase();
  if (s === "ottima" || s === "buona") return "border-forensic-green text-forensic-green bg-forensic-green/10";
  if (s === "media") return "border-forensic-amber text-forensic-amber bg-forensic-amber/10";
  if (s === "limitata") return "border-orange-600 text-orange-700 bg-orange-100";
  if (s === "molto limitata") return "border-forensic-red text-forensic-red bg-forensic-red/10";
  return "border-slate-300 text-slate-600 bg-slate-100";
}
